jQuery(document).ready(function () {
    var symplurTerms = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.whitespace,
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        prefetch: '/api/topics'
    });

    jQuery('#searchform .search-query').typeahead(null, {
        name: 'symplurTerms',
        source: symplurTerms,
        limit: 10,
    }).on('typeahead:selected', function(e, data) {
        jQuery('#searchform').submit();
    });

    // Submit Hashtag Topics Autocomplete
    jQuery('#inputTags').tagsinput({
        maxTags: 8,
        freeInput: true,
        typeaheadjs: {
            name: 'symplurTerms',
            source: symplurTerms,
            limit: 10,
            confirmKeys: [13, 44, 59],
        }
    });
});
